export default "__VITE_ASSET__Dd5DIobb__"